import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import { LanguageSwitch } from "../../../components/language-switch";
import PoweredByButton from "./powered-by-button";
import RegisterLink from "../../login/register-link";
import { useBranding } from "../../../contexts/branding";

interface Props {
    hideRegistartionLink?: boolean;
}

export default function Footer({ hideRegistartionLink }: Props) {
    const { label } = useBranding();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <div className="margin-top-12">
            {hideRegistartionLink ? null : (
                <div className="col-md-12 mb-12 text-align-center">
                    <RegisterLink />
                </div>
            )}
            {location.pathname !== "/new-feedbacks" && (
                <div className="col-md-12 mb-12 text-align-center">
                    <Button
                        onClick={() => {
                            navigate("/new-feedbacks");
                        }}
                        role="button"
                        variant="link"
                        className={
                            label !== "HabitNu"
                                ? "btn ada-link"
                                : "btn theme-text"
                        }
                    >
                        {t("need_help")}
                    </Button>
                </div>
            )}

            <div className="text-center m-auto language-switch-container">
                <LanguageSwitch />
            </div>
            <PoweredByButton />
        </div>
    );
}
